// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jZXE","footer":"styles_footer__1nhLS","passCodeTooltip":"styles_passCodeTooltip__108-j"};